import gql from 'graphql-tag';

export const GET_MODELS_FOR_MAKE = gql`
  query getModelsForMake($forMake: String!) {
    vehicleSelection {
      models: modelsForMake(forMake: $forMake)
    }
  }
`;

export const GET_YEARS_FOR_MAKE_AND_MODEL = gql`
  query getYearsForMakeAndModel($forMake: String!, $forModel: String!) {
    vehicleSelection {
      years: yearsForMakeAndModel(forMake: $forMake, forModel: $forModel) {
        description
        id
      }
    }
  }
`;

export const GET_ASSEMBLIES = gql`
  query getAssemblies($forTrimId: String!) {
    vehicleSelection {
      assemblies(forTrimId: $forTrimId) {
        id
        description
      }
    }
  }
`;

export const GET_MAKES = gql`
  query getMakes($forYear: String!) {
    vehicleSelection {
      makes(forYear: $forYear)
    }
  }
`;

export const GET_MODELS = gql`
  query getModels($forYear: String!, $forMake: String!) {
    vehicleSelection {
      models(forYear: $forYear, forMake: $forMake) {
        description
        id
      }
    }
  }
`;

export const GET_TIRE_CROSS_DIMENSIONS = gql`
  query getTireCrossDimensions($forWidth: String!) {
    tireAspectRatios(forWidth: $forWidth)
  }
`;

export const GET_TIRE_DIAMETERS = gql`
  query getTireDiameters($forWidth: String!, $forAspectRatio: String!) {
    tireDiameters(forWidth: $forWidth, forAspectRatio: $forAspectRatio)
  }
`;

export const GET_TIRE_DIMENSIONS = gql`
  query getTireDimensions {
    tireWidths
    tireHeights
  }
`;

export const GET_TRIMS = gql`
  query getTrims($forVehicleId: String!) {
    vehicleSelection {
      trims(forVehicleId: $forVehicleId) {
        id
        description
      }
    }
  }
`;

export const GET_RIDE_HEIGHTS = gql`
  query getRideHeights($forVehicleId: String!, $forTrimId: String!) {
    vehicleSelection {
      rideHeights(forVehicleId: $forVehicleId, forTrimId: $forTrimId) {
        id
        description
        type
      }
    }
  }
`;

export const GET_WHEEL_BOLT_PATTERNS = gql`
  query getWheelBoltPatterns($forDiameter: String!, $forWheelWidth: String!) {
    boltPatterns(forDiameter: $forDiameter, forWheelWidth: $forWheelWidth)
  }
`;

export const GET_WHEEL_DIAMETERS = gql`
  query getWheelDiameters {
    wheelDiameters
  }
`;

export const GET_WHEEL_WIDTHS = gql`
  query getWheelWidths($forDiameter: String!) {
    wheelWidths(forDiameter: $forDiameter)
  }
`;

export const GET_YEARS = gql`
  query getYears {
    vehicleSelection {
      years
    }
  }
`;

const optionalSizesFields = gql`
  fragment optionalSizesFields on FitmentData {
    vehicleAssembly {
      optionalStaggeredSet {
        offset
        size {
          front
          rear
        }
        matchQualifier
      }
      tireSizes {
        axleType
        sizeQualifier
        wheelSize
        optionalTireSizes {
          tireSize
          matchQualifier
        }
      }
    }
  }
`;

export const GET_OPTIONAL_SIZES = gql`
  query getOptionalSizes(
    $trimId: String!
    $vehicleId: String!
    $assemblyId: String!
    $rideHeight: RideHeightInput
  ) {
    vehicleSelection {
      fitment(
        trimId: $trimId
        vehicleId: $vehicleId
        assemblyId: $assemblyId
        rideHeight: $rideHeight
      ) {
        ...optionalSizesFields
      }
    }
  }
  ${optionalSizesFields}
`;

export const GET_FITMENT_IMAGE = gql`
  query getFitmentImage(
    $forYear: String!
    $forMake: String!
    $forModel: String!
  ) {
    vehicleSelection {
      vehicleDetailsForYearMakeModel(forYear: $forYear, forMake: $forMake, forModel: $forModel){
        vehicleLargeImage{
          url
        }
        vehicleSmallImage{
          url
        }
      }
    }
  }
`;
